import React from 'react';
import { HelpCircle, Book, MessageCircle, Mail } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { PageHeader } from '../../components/shared/PageHeader';

export const HelpPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Help & Support"
        description="Get help and access documentation"
        icon={HelpCircle}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card>
          <CardHeader>
            <Book className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Documentation</CardTitle>
            <CardDescription>
              Browse our comprehensive guides and tutorials
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">
              View Documentation
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <MessageCircle className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Community Forum</CardTitle>
            <CardDescription>
              Connect with other users and share knowledge
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">
              Visit Forum
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <Mail className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Contact Support</CardTitle>
            <CardDescription>
              Get in touch with our support team
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">
              Contact Us
            </Button>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Quick Start Guide</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <h3 className="font-semibold mb-2">1. Set up your client account</h3>
            <p className="text-sm text-muted-foreground">
              Configure your client settings and invite team members
            </p>
          </div>
          <div>
            <h3 className="font-semibold mb-2">2. Add your first project</h3>
            <p className="text-sm text-muted-foreground">
              Create project profiles and manage project details
            </p>
          </div>
          <div>
            <h3 className="font-semibold mb-2">3. Configure integrations</h3>
            <p className="text-sm text-muted-foreground">
              Connect Jira and QuickBooks for seamless workflow
            </p>
          </div>
          <div>
            <h3 className="font-semibold mb-2">4. Create your first job</h3>
            <p className="text-sm text-muted-foreground">
              Start tracking work and managing projects
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
